
	export default {
		components: {},
		data: function () {
			return {
				quantity: 1,
				message: "",
				maxMessageLength: 200,
				modalBasket: [],
			};
		},
		computed: {
			/**
			 * Facilitates the product message counter and splicing the message length to the max allowed
			 */

			messageLength() {
				if (this.message.length > this.maxMessageLength)
					this.message = this.message.substring(0, this.maxMessageLength);
				return (
					"<small>" + this.message.length + "</small> / " + this.maxMessageLength
				);
			},

			productQuantity: {
				get: function () {
					return this.quantity;
				},
				set: function (modifiedValue) {
					if (modifiedValue > 999) modifiedValue = 999;

					if (modifiedValue < 0) modifiedValue = 1;

					this.quantity = modifiedValue;
				},
			},

			isMobile() {
				return this.$store.getters.getIsMobile;
			},

			modalWidth() {
				return this.isMobile ? "100%" : 550;
			},
		},
		props: ["product", "soldOut", "showSchedulingFlag"],
		created: function () {},

		methods: {
			/**
			 * Change the quantity model for this product
			 * @type {integer} incremenet of direction (-1,1)
			 * @return void
			 */

			changeQuantity(increment) {
				this.quantity = Number(this.quantity) + increment;

				if (this.quantity <= 0) this.quantity = 1;

				if (this.quantity > 50) this.quantity = 50;
			},

			/**
			 * Creates basket configuration for products to add to basket
			 * @return object
			 */

			getProductConfiguration() {
				let toReturn = [];

				for (let index in this.product.PriceModifiers) {
					// default to email fulfilment, unless that's not an option
					let has_email_delivery =
						this.product.PriceModifiers[index].Product.FulfilmentMethods.filter(
							(fm) => fm.id == 1
						).length > 0;
					let delivery_type = has_email_delivery
						? 1
						: this.product.PriceModifiers[index].Product.FulfilmentMethods[0].id;

					// if fulfilling by post, and post message is inactive, unset it.
					let message =
						delivery_type == 2 &&
						!this.$store.getters.getAccount
							.custom_message_for_postal_products_active
							? ""
							: this.message;

                    const product_id = this.product.PriceModifiers[index].Product.id;
                    const product = this.getProductByID(product_id);

					let toAdd = {
						id: product_id,
						name: this.product.name,
						price_modifier: this.product.PriceModifiers[index].id,
						quantity: this.quantity,
						message: message,
						delivery_type: delivery_type,
                        allow_scheduling: product.allow_scheduling,
                        hard_expiry_at: product.CurrentExpiryConfig.hard_expire_at,
            show_mobile_delivery: this.allowMobileDelivery(this.product.PriceModifiers[index].Product, delivery_type),
            quantity_config: this.createQuantityConfig(
							delivery_type,
							this.quantity,
                            product
						),
					};

					toReturn.push(toAdd);
				}

				return toReturn;
			},

			/**
			 * Creates basket fulfilment and quantity configuration for products to add to basket
			 * @param int {delivery_type} id of fulfilment method
			 * @param int {quantity} quantity of product to add
			 * @return object
			 */

			createQuantityConfig(delivery_type, quantity, product) {
				var toReturn = [];
				var iteration = 0;

				while (iteration < quantity) {
					iteration++;

					var config = {
						name: "",
						address_line_1: "",
						address_line_2: "",
						town_city: "",
						postcode: "",
						post_type: false,
						email: "",
						email_type: false,
                        schedule_selected: product.allow_scheduling ? 'now' : null,
                        scheduled_date: null,
                        scheduled_time: null,
					};

					toReturn.push(config);
				}

				return toReturn;
			},

			// adds the products in the bundle to the basket
			addProductToBasket() {
				var products = this.getProductConfiguration();

				for (let index in products) {
					this.$store.commit("basket/PUSH_TO_BASKET", products[index]);
				}

				let bundleProducts = this.product.PriceModifiers;
				for (let index in bundleProducts) {
					var modalProduct = { name: bundleProducts[index].Product.name };
					this.modalBasket.push(modalProduct);
				}

				this.show("add_to_basket");
			},

			// validate the form and then perform callback
			validateForm(callback, callback_args) {
				this.$validator.validateAll().then((result) => {
					if (result) {
						callback(callback_args);
					} else {
						this.scrollToError();
					}
					return false;
				});
			},

			// adds the products in the bundle to the basket and return to home screen
			addToBasketContinueShopping() {
				if (!this.validateForm(this.addToBasketCallback, false)) return;
			},

			// adds the products in the bundle to the basket and navigate to basket
			addToBasketCheckout() {
				if (!this.validateForm(this.addToBasketCallback, true)) return;
			},

			/**
			 * add product to basket and navigate to next page
			 * @type {boolean} true for go straight to checkout, false for conitnue shopping
			 * @return void
			 */

			addToBasketCallback(checkout) {
				this.addProductToBasket();
				if (checkout) this.navigateToBasket();
			},

			navigateToBasket() {
				this.modalBasket = [];
				this.$router.push({ name: "basket" });
			},

			handleHideBasketModal() {
        this.hide("add_to_basket");
      },

			/**
			 * show or hide a modal
			 */
			show(modal) {
				this.$modal.show(modal);
			},
			hide(modal) {
				this.modalBasket = [];
				this.$modal.hide(modal);
			},
		},
	};
